// ABOUTME: The row of export-format buttons (square, story, wide) of a share-as-image modal.
// ABOUTME: One control for every card that exports to social formats.

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { SHARE_FORMAT_KEYS, type ShareFormatKey } from "@shared/lib/shareImage"
import { CButton } from "./CButton"
import { CLabel } from "./CLabel"

export const ShareFormatPicker: FC<{ value: ShareFormatKey; onChange: (key: ShareFormatKey) => void }> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div>
      <CLabel className="mb-2 block">{t("statistics.share.format")}:</CLabel>
      <div className="flex gap-2">
        {SHARE_FORMAT_KEYS.map((key) => (
          <CButton
            key={key}
            onClick={() => onChange(key)}
            color={value === key ? "blue" : "gray"}
            label={t(`statistics.share.formats.${key}`)}
            className="flex-1"
          />
        ))}
      </div>
    </div>
  )
}
